var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "waba-supsis-partner-app-installed" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("auto.whatsappBusinessApiV2PartnerAppInstalled"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "meta" }, [
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.event")))]),
        _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.event"))),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.channelId")))]),
        _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.wabaId")))]),
        _vm._v(
          ": " + _vm._s(_vm.$_.get(_vm.activity, "payload.waba_info.waba_id"))
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.ownerBusinessId")))]),
        _vm._v(
          ": " +
            _vm._s(
              _vm.$_.get(_vm.activity, "payload.waba_info.owner_business_id")
            )
        ),
      ]),
      _vm._v(" "),
      _vm.$_.get(_vm.activity, "payload.waba_info.partner_app_id")
        ? _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.$t("auto.partnerAppId")))]),
            _vm._v(
              ": " +
                _vm._s(
                  _vm.$_.get(_vm.activity, "payload.waba_info.partner_app_id")
                ) +
                "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$_.get(_vm.activity, "payload.waba_info.solution_id")
        ? _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.$t("auto.solutionId")))]),
            _vm._v(
              ": " +
                _vm._s(
                  _vm.$_.get(_vm.activity, "payload.waba_info.solution_id")
                ) +
                "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.solutionPartnerBusinessIdsStr
        ? _c("div", [
            _c("b", [
              _vm._v(_vm._s(_vm.$t("auto.solutionPartnerBusinessIds"))),
            ]),
            _vm._v(
              ": " + _vm._s(_vm.solutionPartnerBusinessIdsStr) + "\n        "
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("details", { staticClass: "raw" }, [
      _c("summary", [_vm._v(_vm._s(_vm.$t("auto.rawPayload")))]),
      _vm._v(" "),
      _c("pre", [_vm._v(_vm._s(_vm.prettyPayload))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }